import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveLeague, useUpdateLeague } from "../api/LeagueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { LeagueForm } from "./LeagueForm";
export const UpdateLeague = () => {
    const { id } = useNumericParams();
    const navigate = useNavigate();
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserLeaguePermissions({ leagueId: id });
    const { canModify = false } = permissions || {};
    const { data: league, isLoading: isLeagueLoading, error: leagueError, } = useRetrieveLeague({ id, enabled: canModify });
    const [loading, setLoading] = useState(false);
    const mutation = useUpdateLeague({
        id,
        onMutate: () => setLoading(true),
        onSuccess: (data) => {
            const league = data.data;
            navigate(`/leagues/${league.id}/`);
        },
        onError: () => {
            setLoading(false);
        },
    });
    const handleSubmit = (data) => {
        mutation.mutate(data);
    };
    if (permissionsLoading || loading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (isLeagueLoading) {
        return _jsx(Loading, {});
    }
    if (leagueError || !league) {
        return _jsx(ErrorView, { error: leagueError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update league. Please try again.", onClose: () => { } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: _jsxs("strong", { children: ["Update ", league.name] }) }), _jsx(LeagueForm, { league: league, onSubmit: handleSubmit })] }));
};
